import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { EventDetails } from '../components/EventDetails';
import { CoachSection } from '../components/CoachSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForYouSection } from '../components/ForYouSection';
import { OfferSection } from '../components/OfferSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function NocheDeImpacto() {
  return <div className="min-h-screen font-sans selection:bg-[#5B2D8E] selection:text-white scroll-smooth" data-id="element-206">
      <HeroSection data-id="element-207" />
      <ProblemSection data-id="element-208" />
      <SolutionSection data-id="element-209" />
      <EventDetails data-id="element-210" />
      <CoachSection data-id="element-211" />
      <TestimonialsSection data-id="element-212" />
      <ForYouSection data-id="element-213" />
      <OfferSection data-id="element-214" />
      <FAQSection data-id="element-215" />
      <FinalCTA data-id="element-216" />
      <Footer data-id="element-217" />
    </div>;
}